import { MdClose } from "react-icons/md";
import styles from './discountBar.module.css';
import { motion } from 'framer-motion';
import { Button } from '@mui/material';
import { useNavigate } from "react-router-dom";


export default function DiscountBar({ close }) {

  const navigateTo = useNavigate();

  function handleBoxClick() {
    navigateTo('/discounts');
    close();
  }


  return (
    <motion.div
      className={`${styles.container} d-flex justify-content-between align-items-center gap-1 gap-sm-3 bg-warning px-2 px-sm-4`}
      initial={{ opacity: 0, y: -60 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className={`${styles.box} d-flex align-items-center flex-fill h-100`} onClick={handleBoxClick}>
        <div className='d-sm-none'>
          <img className={styles.offer} src="/assets/images/discounts/offer.png" alt="offer" />
          مشاهده فروش ویژه
        </div>
        <div className='d-none d-sm-block'>
          <img className={styles.offer} src="/assets/images/discounts/offer.png" alt="offer" />
          مشاهده محصولات مشمول تخفیف ویژه
        </div>
      </div>

      <MdClose className={`${styles.mobileCloseBtn} d-sm-none`} onClick={close} />
      <Button className={`${styles.desktopCloseBtn} d-none d-sm-block`} type='button' variant='contained' color='error' onClick={close}>بستن</Button>
    </motion.div>
  )
}
